import { render, staticRenderFns } from "./PurchaseRequestDetailUpload.vue?vue&type=template&id=42b54b38&"
import script from "./PurchaseRequestDetailUpload.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequestDetailUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports